import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import { RecoilRoot } from "recoil";

import "assets/css/App.css";
import theme from "theme/theme";
import AppRoutes from "routes/AppRoutes";

const rootElement = document.getElementById("root");
ReactDOM.createRoot(rootElement).render(
  <ChakraProvider
    theme={theme}
    toastOptions={{ defaultOptions: { position: "bottom" } }}
  >
    <RecoilRoot>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </RecoilRoot>
  </ChakraProvider>,
);
